'use client'

import * as React from 'react'
import {
  Tabs,
  TabsList as DesignTabsList,
  TabsListProps,
  TabsTrigger as DesignTabsTrigger,
  TabsTriggerProps,
  TabsContent as DesignTabsContent,
  TabsContentProps
} from 'design-configuration/components/tabs'

import { cn } from '@/lib/utils'

const TabsList = React.forwardRef<React.ElementRef<typeof DesignTabsList>, TabsListProps>(
  ({ className, ...props }, ref) => (
    <DesignTabsList
      ref={ref}
      className={cn('rounded-xs border-outline-variant w-full items-stretch border p-0', className)}
      {...props}
    />
  )
)
TabsList.displayName = DesignTabsList.displayName

const TabsTrigger = React.forwardRef<React.ElementRef<typeof DesignTabsTrigger>, TabsTriggerProps>(
  ({ className, ...props }, ref) => (
    <DesignTabsTrigger
      ref={ref}
      className={cn(
        'data-[state=active]:bg-primary-8 disabled:bg-primary-8 border-r-outline-variant text-on-surface-variant bg-surface data-[state=active]:text-on-surface p-xs data-[state=inactive]:hover:bg-surface-low flex-1 rounded-none border-r text-center text-lg font-normal last:border-r-0 disabled:opacity-100 data-[state=active]:font-medium',
        className
      )}
      {...props}
    />
  )
)
TabsTrigger.displayName = DesignTabsTrigger.displayName

const TabsContent = React.forwardRef<React.ElementRef<typeof DesignTabsContent>, TabsContentProps>(
  ({ className, ...props }, ref) => <DesignTabsContent ref={ref} className={cn('mt-0', className)} {...props} />
)
TabsContent.displayName = DesignTabsContent.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
